import React, { useEffect, useState, memo, useContext } from "react";
import { Button, Card, Divider, Image, InputNumber, Typography } from "antd";
import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { IConsumableItemProps } from "@Components/consumables/types";
import { MainContext } from "@Context/provider";
import { ViewMode } from "@Context/state";
const { Title } = Typography;

const ConsumableItem: React.FC<IConsumableItemProps> = (props: IConsumableItemProps) => {
    const { ui: uiState } = useContext(MainContext);

    const [amount, setAmount] = useState<number>(0);
    const [disabled, setDisabled] = useState<boolean>(false);

    const onTypeNumeral = (newAmount) => {
        if (newAmount < 0) newAmount = 0;
        setAmount(newAmount);
    };
    const onMinusClick = () => {
        if (amount === 0) return;
        setAmount((prevState) => prevState - 1);
    };
    const onPlusClick = () => {
        setAmount((prevState) => prevState + 1);
    };
    const onAddClick = () => {
        const { addConsumable, ...item } = props;
        if (amount && !disabled) addConsumable(item, amount);
    };

    useEffect(() => {
        if (props.remainingCredits - amount * props.creditPrice < 0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }
    }, [amount, props.remainingCredits]);

    return (
        <Card className="consumable-item newUI-subtle">
            {uiState.mode !== ViewMode.mobile && (
                <div className="consumable-image-container flex">
                    <Image className="consumable-image" src={props.imageUrl} />
                </div>
            )}
            <div className="description">
                <Title level={5} style={{ margin: "0 0 5px 0" }}>
                    {props.name}
                </Title>
                <div style={{ margin: "0 0 5px 0" }}>Code: {props.productCode}</div>
                <div>{props.description}</div>
                <Divider />
                <div>Credits: {props.creditPrice}</div>
            </div>
            <div className="actions">
                <div className="amount">
                    <Button
                        className="secondary"
                        shape="circle"
                        icon={<MinusCircleOutlined />}
                        size="large"
                        onClick={onMinusClick}
                    />
                    <InputNumber
                        className="input-number"
                        min={0}
                        defaultValue={0}
                        controls={false}
                        value={amount}
                        onChange={(val) => onTypeNumeral(val)}
                    />
                    <Button
                        className="secondary"
                        shape="circle"
                        icon={<PlusCircleOutlined />}
                        size="large"
                        onClick={onPlusClick}
                    />
                </div>
                <Button
                    className="secondary"
                    icon={<PlusCircleOutlined />}
                    size="large"
                    onClick={onAddClick}
                    disabled={
                        props.creditDetails.drawDownValue === 0 ||
                        props.creditPrice > props.remainingCredits ||
                        disabled
                    }
                >
                    ADD
                </Button>
            </div>
        </Card>
    );
};
export default memo(ConsumableItem);
